//#region namespace
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
// import { InvoiceService } from '../../service/invoice.service';
// import { SrcFilterPipe } from '../../shared/srcfilter';
// import { DateFormatPipePipe } from '../../shared/date-format-pipe.pipe';
// import { TempUserLoginHandlerService } from '../../service/temp-user-login-handler.service';
// import * as _ from 'underscore';
// import { PagerService } from '../../shared/pagerService';
import * as $ from 'jquery';
import { Input } from '@angular/core';
import { AppConfig } from '../../app.configsettings';
// import { AdminServiceService } from '../../service/admin-service.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { UserManagementService } from '../../Services/user-management/user-management.service';
import { ToastrService } from 'ngx-toastr';
import { AppOfflineStore } from '../../app.offlineService';
import { DatePipe } from '@angular/common';
import { Login } from '../../interfaces/interfaces/login';
import { AuthService } from '../../Services/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
// import { ApiheadersService } from '../../service/apiheaders.service';
import * as CryptoJS from 'crypto-js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentManagementNavigatorComponent } from '../master/content-management-navigator/content-management-navigator.component';
import { SessionService } from 'src/app/Services/session.service';
import { LastRouteService } from 'src/app/Services/last-route.service';
declare const openFullscreen: any;
declare const showpasword: any;
@Component({
  selector: 'app-userlogin',
  templateUrl: './userlogin.component.html',
  styleUrls: ['./userlogin.component.css'],
})
export class UserloginComponent implements OnInit {
  @Output() EnableMenus: EventEmitter<any> = new EventEmitter();
  secretKey = '@perfectlearing.com/';
  // passwordlist: setpassword;
  key = CryptoJS.enc.Utf8.parse('8056483646328763');
  iv = CryptoJS.enc.Utf8.parse('8056483646328763');
  data: any;
  Username: string;
  Password: string;
  loginForm = new FormGroup({
    userName: new FormControl(''),
    password: new FormControl(),
  });
  ds: any;
  loginError: boolean;
  loginEmptyError: boolean;
  pathname: string;
  formdata: FormGroup;
  // model: Login = { userid: "admnin", password: "admin@123" }
  constructor(
    public p: AppConfig,
    public _route: Router,
    public _toast: ToastrService,
    public _offStorage: AppOfflineStore,
    public datepipe: DatePipe,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public userService: UserManagementService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private last: LastRouteService,
    private authSvc: AuthService
  ) {
    this.pathname = '';
    this.pathname = window.location.pathname;
    if (this.pathname === '/login' || this.pathname === '/') {
      this.p.urlPath = true;
    } else {
      this.p.urlPath = false;
    }
    this.loginError = false;
    this.loginEmptyError = false;
    //this.EnableMenus.emit(false);
  }

  showpassword1: Boolean = false;
  showpasswordhideshow() {
    this.showpassword1 = !this.showpassword1;
    showpasword();
  }

  ngOnInit() {
    this.formdata = new FormGroup({
      emailid: new FormControl(''),
      passwd: new FormControl(''),
    });
    if(this.authSvc.isLoggedIn()){
      this.router.navigate(['/Admin/Dashboard']);
    }
    //this.EnableMenus.emit(false);
    this.sessionService.emitCourse(false);
  }

  get() {
    if (this.Username === '') {
      this._toast.warning('Enter User Name.');
    } else if (this.Username === '') {
      this._toast.warning('Enter Password.');
    }
    if (this.Username !== '' && this.Password !== '') {
      let uName = this.Username;
      let uPwd = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(this.Password),
        this.key,
        {
          keySize: 128 / 8,
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      ).toString();

      //let uPwd = this.Password;
      let data = { Username: uName, Password: uPwd };
      this.userService.userAuthentication(data).subscribe(
        (i: any) => {
          this.ds = i;

          const expiresUtc = new Date(this.ds['.expires']); // server says GMT
          const issuedUtc = new Date(this.ds['.issued']);
          localStorage.setItem('userToken', this.ds.access_token);
          localStorage.setItem('expires_in', this.ds.expires_in);

    // (Optional) also store pretty local times for debugging / display
          localStorage.setItem('expires_at_local', expiresUtc.toString()); // toString() = local time
          localStorage.setItem('issued_at_local', issuedUtc.toString());
          localStorage.setItem('loginuser', this.ds.username);
          localStorage.setItem('roles', this.ds.roles);
          localStorage.setItem('refresh_token', this.ds.refresh_token);
          this.EnableMenus.emit(true);
          const qp = this.route.snapshot.queryParamMap;
          const redirect = qp.get('redirect') || this.last.get() || '/';
          if(redirect !== '/'){
          this.router.navigateByUrl(redirect);}
          else{
          this.router.navigate(['/Admin/Dashboard']);
          this.open();
          }
        },
        (err: HttpErrorResponse) => {
          this.loginError = true;
          this.EnableMenus.emit(false);
        }
      );
    } else {
      this.loginEmptyError = true;
      this.EnableMenus.emit(false);
    }
  }

  open(route?: string, param?: string) {
    this.modalService.dismissAll();
    const params = this.route.snapshot.queryParams; // One-time read of query params

    const modalRef = this.modalService.open(
      ContentManagementNavigatorComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      }
    );
    modalRef.componentInstance.route = route || null;
    modalRef.componentInstance.param = param || null;
  }
}

export class _user {
  Username: string;
  Password: string;
}
